import React from 'react';
import PropTypes from 'prop-types';

import { Title } from '../../title';
import {
  Container, CloseCarousel, Shadow, BlueButton, ButtonContainer,
} from '../styles/footer-modal.style';
import {
  RTE,
} from '../../../utils/atoms';

const propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
};

const defaultProps = {
  title: '',
  content: {
    childMarkdownRemark: {},
  },
};

/**
 * Footer modal Component
 * @param {object} props Incoming Props
 * @returns {XML} Footer modal Component
 */
const FooterModal = ({ title, content, close }) => (
  <Shadow onClick={() => close()}>
    <Container onClick={e => e.stopPropagation()}>
      <Title black>{title}</Title>
      <RTE
        dangerouslySetInnerHTML={{
          __html: content && content.childMarkdownRemark && content.childMarkdownRemark.html,
        }}
        className="footer-modal"
      />
      <CloseCarousel onClick={() => close()}>
        <img src="/images/close.svg" alt="Close" />
      </CloseCarousel>
      <ButtonContainer>
        <BlueButton onClick={() => close()}>
          <span>close</span>
        </BlueButton>
      </ButtonContainer>
    </Container>
  </Shadow>
);

FooterModal.defaultProps = defaultProps;
FooterModal.propTypes = propTypes;

export default FooterModal;



// WEBPACK FOOTER //
// ./src/components/footer-modal/components/footer-modal.js